module.exports = __webpack_public_path__ + "img/_ABS9846(1).e843c614.jpg";